import { combineReducers } from "redux";
import { mailingAddressAnyReducer, mailingAddressReducer, updateMailingAddressReducer } from "./mailingAddress";

const mailingAddressRoot = combineReducers({
    mailingAddress: mailingAddressReducer,
    mailingAddressAny: mailingAddressAnyReducer,
    updateMailingAddress: updateMailingAddressReducer
});

export default mailingAddressRoot;